import React, { ReactNode } from 'react';
import { ContainerCheckBox, ContainerDataRequestItem } from './styles';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';
import { RoundHelper } from '../../../../utils/roundHelper';

function ValueText({title, value}: { title: string, value: string }) {
    return (
        <ContainerDataRequestItem>
                <span>{title}</span>
                <span>{value}</span>
            </ContainerDataRequestItem>
    )
}

function ValueNumber({title, value, allowValueZero}: { title: string, value?: number, allowValueZero?: boolean }) {
    if (!value && !allowValueZero) {
        return <></>
    }

    return (
        <ContainerDataRequestItem>
                <span>{title}</span>
                <span>
                    {RoundHelper.toFormatted(value || 0)}
                </span>
        </ContainerDataRequestItem>
    )
}

function Root({ children }: {
    children: ReactNode
}) {
    return (
        <>
            {children}
        </>
    )
}

function BalanceCustomer({title, value}: { title: string, value?: number }) {
    if (!value) {
        return <></>;
    }
    const force = true;
    return (
        <>
            <ValueNumber title={title} value={value}/>
            <ContainerCheckBox>{
                force ? <ImCheckboxChecked color="var(--primary)" size={15} /> : <ImCheckboxUnchecked color="#ccc" size={15} />    
            } Usar saldo na compra atual</ContainerCheckBox>
        </>
    )
}

export const CheckoutTotals = {
    Root,
    Services: ValueNumber,
    Discount: ValueText,
    SubTotal: ValueText,
    Total: ValueText,
    Shipping: ValueText,
    BalanceCustomer,
} 
